import * as React from 'react'
import { AddChip } from '@/components/ui/add-chip'
import { DateTimePicker } from '@/components/ui/date-time-picker'

export function CloseRegistrationControl({
  value,
  onChange,
}: {
  value: string
  onChange: (value: string) => void
}) {
  const [editing, setEditing] = React.useState(value !== '')

  if (!editing) {
    return <AddChip onClick={() => setEditing(true)}>Set a close time</AddChip>
  }

  return (
    <DateTimePicker
      id="registration-closes-at"
      label="Close registration"
      value={value}
      onChange={(nextValue) => {
        onChange(nextValue)
        setEditing(nextValue !== '')
      }}
    />
  )
}
